export interface TimeFilterOption {
	value: string;
	label: string;
	hours: number;
}

export const defaultTimeFilterOption: TimeFilterOption = {
	value: "all",
	label: "30d",
	hours: 30 * 24,
};

export const timeFilterOptions: TimeFilterOption[] = [
	{ value: "6h", label: "6h", hours: 6 },
	{ value: "24h", label: "24h", hours: 24 },
	{ value: "3d", label: "3d", hours: 3 * 24 },
	{ value: "7d", label: "7d", hours: 7 * 24 },
	{ value: "14d", label: "14d", hours: 14 * 24 },
	defaultTimeFilterOption,
];
